import React from 'react';
import ReactDOM from 'react-dom/client';
import { 
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider
 } from 'react-router-dom';
 import { Provider } from 'react-redux';
import store from './store';
// import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles/bootstrap.min.css';
import './assets/styles/index.css';
import App from './App';
import PrivateRoute from './components/PrivateRoute.jsx';
import HomeScreen from './screens/HomeScreen';
import VerkoopScreen from './screens/VerkoopScreen';
import CartScreen from './screens/CartScreen';
import BedanktScreen from './screens/BedanktScreen';
import BarcodeScreen from './screens/BarcodeScreen';
import LoginScreen from './screens/LoginScreen';
import RegisterScreen from './screens/RegisterScreen.jsx';
import ForgotPasswordScreen from './screens/ForgotPasswordScreen.jsx';
import ResetPasswordScreen from './screens/ResetPasswordScreen.jsx';
import PlaceOrderScreen from './screens/PlaceOrderScreen';
import OrderScreen from './screens/OrderScreen';
import ShippingLabelScreen from './screens/ShippingLabelScreen';
import ShipmentTrackingScreen from './screens/ShipmentTrackingScreen.jsx';
import ProfileScreen from './screens/ProfileScreen.jsx';
import OrderListScreen from './screens/admin/OrderListScreen.jsx';
import UserListScreen from './screens/admin/UserListScreen.jsx';
import UserEditScreen from './screens/admin/UserEditScreen.jsx';
import UserDetailScreen from './screens/admin/UserDetailScreen.jsx';
import UserItemsScreen from './screens/admin/UserItemsScreen.jsx';
import reportWebVitals from './reportWebVitals';
import MyOrdersScreen from './screens/MyOrdersScreen.jsx';
import PrivacyScreen from './screens/PrivacyScreen.jsx';
import AboutScreen from './screens/AboutScreen.jsx';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>

      {/* Public routes */}
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/register" element={<RegisterScreen />} />
      <Route path="/privacy" element={<PrivacyScreen />} />
      <Route path="/over-ons" element={<AboutScreen />} />
      <Route path="/forgotpassword" element={<ForgotPasswordScreen />} />
      <Route path="/resetpassword/:resetToken" element={<ResetPasswordScreen />} />

      {/* Protected routes */}
      <Route element={<PrivateRoute />}>
        <Route index={true} path="/" element={<HomeScreen />} />
        <Route path="/verkoop" element={<VerkoopScreen />} />
        <Route path="/cart" element={<CartScreen />} />
        <Route path="/bedankt" element={<BedanktScreen />} />
        <Route path="/barcode" element={<BarcodeScreen />} />
        <Route path='/placeorder' element={<PlaceOrderScreen />} />
        <Route path='/order/:id' element={<OrderScreen />} />
        <Route path='/order/:id/label' element={<ShippingLabelScreen />} />
        <Route path='/order/:id/track' element={<ShipmentTrackingScreen />} />
        <Route path='/profile' element={<ProfileScreen />} />
        <Route path='/orders' element={<MyOrdersScreen />} />

        {/* Admin routes (optional, if you want to restrict further) */}
        <Route path='/admin/orderlist' element={<OrderListScreen />} />
        <Route path='/admin/userlist' element={<UserListScreen />} />
        <Route path='/admin/user/:id/edit' element={<UserEditScreen />} />
        <Route path="/users/:id" element={<UserDetailScreen />} />
        <Route path="/admin/users/:id/items" element={<UserItemsScreen />} />

      </Route>

    </Route>
  )
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
